<template>
	<div class="w-100 h-100 d-flex align-items-center justify-content-center">Service</div>
</template>

<script setup>
	import { watch } from 'vue';
	import { storeToRefs } from 'pinia';
	import { useIdleStore } from '@/stores/useIdleStore';
	import { useLegacyKioskStore } from '@/stores/legacy/kiosk-store';

	const { playIdleVideo } = useIdleStore();
	const legacyKioskStore = useLegacyKioskStore();

	const { kioskStatus } = storeToRefs(legacyKioskStore);

	watch(kioskStatus, () => {
		const payload = kioskStatus.value?.payload;
		const printer1 = payload?.printer1 === 'PAPER_ENOUGH' || payload?.printer1 === 'PAPER_LOW';
		const printer2 = payload?.printer2 === 'PAPER_ENOUGH' || payload?.printer2 === 'PAPER_LOW';
		const isEnoughPaper = printer1 || printer2;

		console.log('ServiceView: ', {
			status: kioskStatus.value,
			payload,
			printer1: payload?.printer1,
			printer2: payload?.printer2,
			isEnoughPaper,
		})

		if (isEnoughPaper) {
			console.log('Paper is not enough, call `api/timeout`');
			playIdleVideo();
		}
	});
</script>